import {
  buildTrackingSteps,
  BASE_STATUS_RANK,
  EVALUATION_STEP,
  OPERATION_STEP,
  CESSION_STEP,
  MONEY_TRANSFER_STEP,
  PAYMENT_STEP,
  riskReviewBullet,
  documentReviewBullet,
  ratificationReviewBullet,
} from '@fingo/lib/features/operations-status';

// BCH: document review / ratification happen in the evaluation phase.
const STATUS_RANK = {
  ...BASE_STATUS_RANK,
  PENDINGDOCUMENTSREVIEW: 1,
  PENDINGRATIFICATION: 1,
  REJECTEDDOCUMENTS: 1,
  REJECTEDRATIFICATION: 1,
};

const BCH_STEPS = [
  {
    ...EVALUATION_STEP,
    getBullets: (invoice, rank) => [
      riskReviewBullet(invoice, rank),
      documentReviewBullet(invoice, rank),
      ratificationReviewBullet(invoice, rank),
    ].filter(Boolean),
  },
  OPERATION_STEP,
  CESSION_STEP,
  MONEY_TRANSFER_STEP,
  PAYMENT_STEP,
];

const buildBchSteps = (invoice) => buildTrackingSteps(invoice, BCH_STEPS, STATUS_RANK);

export default buildBchSteps;
